export default {
      id: "road-usage",
      viewBox: "0 0 26 17",
      url: __webpack_public_path__ + "img/icons.svg#road",
      toString: function () {
        return this.url;
      }
    }